import { render, staticRenderFns } from "./ApnAreaMarinaProtegida.vue?vue&type=template&id=6ee8665e&scoped=true&lang=pug"
import script from "./ApnAreaMarinaProtegida.vue?vue&type=script&lang=js"
export * from "./ApnAreaMarinaProtegida.vue?vue&type=script&lang=js"
import style0 from "./ApnAreaMarinaProtegida.vue?vue&type=style&index=0&id=6ee8665e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee8665e",
  null
  
)

export default component.exports